import { SET_FILTERS, CLEAN_FILTERS } from '../actions/filters';

const initialState = {
    text: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERS: {
            return {
                ...state,
                text: action.payload.text
            };
        }
        case CLEAN_FILTERS:{
            return{
                ...initialState,
            }
        }
        default:
            return state;
    }
};
